<template>
  <div class="grid grid-cols-5 gap-4">
    <div
      class="bg-gray-50 hover:bg-gray-100 hover:cursor-pointer rounded-xs flex justify-center items-center align-middle h-14 w-14"
      v-for="icon in icons"
      :key="icon"
      @click="handleIconSelected(icon)"
    >
      <span
        class="material-symbols-outlined text-3xl"
        :style="{ color: props.color }"
        >{{ icon }}</span
      >
    </div>
  </div>
</template>

<script setup>
import { usePage } from "@inertiajs/vue3";
import { defineEmits, defineProps } from "vue";

const emit = defineEmits(["icon-selected"]);
const props = defineProps({
  color: String,
});

const icons = usePage().props.icons;

const handleIconSelected = (icon) => emit("icon-selected", icon);
</script>
